package uz.ferro.erp.feature.order.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.model.DictItem

@Serializable
data class PackageInfo(
    val productName: DictItem?,
    val activationDate: String?,
    val expirationDate: String?,
    val totalMb: Int?,
    val totalMinutes: Int?,
    val usedMinutes: Int?,
    val usedMb: Int?
)